<template>
  <div>
    <md-menu>
      <md-button
        :to="{ name: 'Building stock summary'}"
        v-if='!siteId'>SYNTHÈSE</md-button>
      <md-button
        :to="{ name: 'Building stock sites'}"
        v-if='!siteId'>SITES</md-button>
      <md-button
        :to="{ name: 'Building stock renewable energies'}"
        v-if='!siteId'>EnR</md-button>
      <md-button
        :to="{ name: 'Building stock file import'}"
        v-if='!siteId'>IMPORT</md-button>
      <md-button
        :to="{ name: 'Building stock site', params: {siteId: siteId}}"
        v-if='siteId'>SYNTHÈSE</md-button>
      <md-button
        :to="{ name: 'Building stock site buildings', params: {siteId: siteId}}"
        v-if='siteId'>DÉTAILS DES BÂTIMENTS</md-button>
    </md-menu>
  </div>
</template>

<script>
export default {
  name: 'BuildingStockHeader',
  props: {
    siteId: {
      type: Number,
      required: false,
      default: null
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/BuildingStockHeader.vue